var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InputGroup,{staticClass:"compact",attrs:{"data":_setup.fieldData,"required":_vm.field.required},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('update', _setup.fieldData.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }